var map = {
	"./dropdown-review": 83792,
	"./free-text-review": 2683,
	"./multi-select-review": 15935,
	"./paragraph-text-review": 35961,
	"./section-break-review": 37226,
	"./section-header-review": 36862,
	"./short-answer-review": 13246,
	"./single-select-review": 51380,
	"./text-fields-review": 84824
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98813;